import React from 'react';
import styles from './Table.module.scss';

const Tr = ({ children, ...props }) => {
  return (
    <tr className={styles.Tr} {...props}>
      {children}
    </tr>
  );
};

export default Tr;
